import React from 'react';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';
import STATE_OPTIONS from '../../../resources/data/states.json';

const StyledSelectInput = styled(SelectInput, {
  'input::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    display: 'none !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
  },
});

export const State = () => {
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <StyledSelectInput
      data-testid="state"
      label="State"
      model={`${modelPrefix}.state`}
      validators={{ required: 'Please select a value' }}
      options={STATE_OPTIONS.sort((a, b) => (a.label > b.label ? 1 : -1))}
      enableOutsideScroll
      isSearchable
      width="50%"
      isClearable
      onBlur={() => onBlur(`${modelPrefix}.state`)}
    />
  );
};
